import { useHookstate } from "@hookstate/core";
import { readerSettingsStore } from "../../../hookstate/readerSettingsStore";

export function useVerticalMargin() {
  const hasVerticalMargin = useHookstate(
    readerSettingsStore.hasVerticalMargin,
  ).get();

  const toggleHasVerticalMargin = () => {
    readerSettingsStore.hasVerticalMargin.set(!hasVerticalMargin);
  };

  return { hasVerticalMargin, toggleHasVerticalMargin };
}
